module.exports = __webpack_public_path__ + "static/media/check.e9744fe0.svg";